<template>
  <div>
    <div class="operations">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="operations__head">
            <div class="operations__head__title">
              <span>Operaciones</span>
            </div>
          </div>
          <div class="operations__body">
            <div class="row">
              <div class="col-md-12">
                <div class="policies__input-dates">
                  <div class="policies__input-dates__input">
                    <div class="input-group mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Ingrese búsqueda"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        @keyup.native.enter="loadOperations()"
                        v-model="query.q"
                      />
                    </div>
                  </div>

                  <div class="policies__input-dates__start-date">
                    <div class="input-group mb-3">
                      <datepicker
                        v-model:model-value="query.startDate"
                        :clearable="false"
                      >
                      </datepicker>
                      <button class="clear-date" @click="clearDate(true)">
                        ✕
                      </button>
                    </div>
                  </div>

                  <div class="policies__input-dates__end-date">
                    <div class="input-group mb-3">
                      <datepicker
                        v-model:model-value="query.endDate"
                        :clearable="false"
                      >
                      </datepicker>
                      <button class="clear-date" @click="clearDate(false)">
                        ✕
                      </button>
                    </div>
                  </div>

                  <div class="policies__input-dates__btn-policies">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="loadOperations()"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
                <div class="operations__body__load" v-if="flags.searching">
                  <i class="fas fa-circle-notch fa-spin d-block mb-1"></i>
                  Cargando operaciones...
                </div>
                <table
                  class="
                    table table-hover table-striped
                    operations__body__table
                  "
                  v-if="!flags.searching"
                >
                  <thead>
                    <tr>
                      <th>P&oacute;liza</th>
                      <th>Tipo</th>
                      <th>Fecha de solicitud</th>
                      <th>Importe</th>
                      <th>Prima</th>
                      <th>A&ntilde;os</th>
                      <th>Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in operations"
                      v-bind:key="item.additionalContributionId"
                    >
                      <td>
                        <router-link
                          :to="{
                            name: 'admineditpolicy',
                            query: {
                              policyNumber: item.policy.referencePolicyId,
                            },
                          }"
                        >
                          {{ item.policy.referencePolicyId }}
                        </router-link>
                      </td>
                      <td>
                        <span v-if="item.additionalContributionType === 1"
                          >Pago adicional</span
                        >
                        <span v-if="item.additionalContributionType === 2"
                          >Endoso</span
                        >
                        <span v-if="item.additionalContributionType === 3"
                          >Congelamiento</span
                        >
                      </td>
                      <td>{{ formatDate(item.createdOn) }}</td>
                      <td>
                        <template
                          v-if="
                            item.additionalContributionType === 1 ||
                            item.additionalContributionType === 2
                          "
                        >
                          <span v-if="item.additionalContributionType === 1"
                            >S/{{ item.amount }}</span
                          >
                          <span
                            v-if="item.additionalContributionType === 2"
                            :class="{
                              'text-danger':
                                item.policy.paymentAmount > item.amount,
                              'text-success':
                                item.policy.paymentAmount < item.amount,
                            }"
                          >
                            <i
                              class="fas fa-arrow-up text-success"
                              v-if="item.policy.paymentAmount < item.amount"
                            ></i>
                            <i
                              class="fas fa-arrow-down text-danger"
                              v-if="item.policy.paymentAmount > item.amount"
                            ></i>
                            S/{{ item.amount }}
                          </span>
                        </template>
                        <template v-if="item.additionalContributionType === 3">
                          --
                        </template>
                      </td>
                      <td>S/{{ item.policy.paymentAmount }}</td>
                      <td>{{ item.policy.periodicity }}</td>
                      <td>
                        <span
                          class="badge badge-purple"
                          v-if="item.additionalContributionStatus === 1"
                          >Pendiente</span
                        >
                        <span
                          class="badge badge-success"
                          v-if="item.additionalContributionStatus === 2"
                          >Aprobado</span
                        >
                        <span
                          class="badge badge-danger"
                          v-if="item.additionalContributionStatus === 3"
                          >Rechazado</span
                        >
                      </td>
                      <td class="operations__body__table__actions">
                        <template v-if="!item.loading">
                          <a
                            role="button"
                            v-if="item.additionalContributionStatus === 1"
                            class="text-main"
                            @click="approve(item)"
                            title="Aprobar"
                          >
                            <i class="fas fa-check"></i>
                          </a>
                          <a
                            role="button"
                            v-if="item.additionalContributionStatus === 1"
                            class="text-danger ml-2"
                            @click="cancel(item)"
                            title="Rechazar"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </template>
                        <i
                          class="fas fa-circle-notch fa-spin"
                          v-if="item.loading"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="pagination"
                v-if="operations && operations.length > 0"
              >
                <pagination
                  v-model="page"
                  :records="rowCount"
                  :per-page="20"
                  @paginate="changePage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-error"
      ok-only
      ok-title="Entiendo"
      centered
      size="sm"
      modal-class="modal-error"
      ref="modal-error"
    >
      <div class="modal-error__head">
        <img :src="require('@/assets/images/app/alert.svg')" alt="" />
        <h3>Ups!</h3>
      </div>
      <div class="modal-error__head">
        <p>
          {{ errors.message }}
        </p>
      </div>
    </b-modal>
  </div>
</template>



<script lang="ts">
import { BButton, BModal, VBModal, BCardText } from "bootstrap-vue";
//import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import Datepicker from "@vuepic/vue-datepicker";
import es from "vuejs-datepicker/dist/locale/translations/es";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import moment from "moment";
import { init } from "echarts/lib/echarts";
import { environment } from "../../../environment/environment";
import { defineComponent } from "vue";
import pagination from "vue-pagination-2";

import "@vuepic/vue-datepicker/dist/main.css";

export default defineComponent({
  components: {
    BCardText,
    VueSlider,
    BModal,
    Datepicker,
    pagination,
  },
  data() {
    return {
      apiUrl: environment.api,
      basePath: window["basePath"],
      operations: [],
      flags: {
        loading: false,
        searching: false,
      },
      query: {
        q: "",
        startDate: null,
        endDate: null,
      },
      es: es,
      errors: {
        message: "",
      },
      page: 1,
      rowCount: 0,
    };
  },
  validations: function () {
    return {};
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    init() {
      this.loadOperations();
    },
    clearDate(t = false) {
      if (t) {
        this.query.startDate = null;
      } else {
        this.query.endDate = null;
      }
    },
    async loadOperations() {
      this.flags.searching = true;

      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      let url = `${this.apiUrl}policies/additional-contributions?page=${this.page}&pageSize=20&q=${this.query.q}`;

      if (this.query.startDate) {
        url += `&startDate=${moment(this.query.startDate).format(
          "MM-DD-YYYY"
        )}`;
      }

      if (this.query.endDate) {
        url += `&endDate=${moment(this.query.endDate).format("MM-DD-YYYY")}`;
      }

      var result = await axios.get(url, headers);

      try {
        if (result.data) {
          let data = result.data;

          data = data.results.map((el) => {
            el.loading = false;
            el.policyNumber = el.referencePolicyNumber
              ? el.referencePolicyNumber.substring(1, el.referencePolicyNumber)
              : "";
            return el;
          });

          this.operations = data;
          this.flags.searching = false;
          this.rowCount = result.data.rowCount;
          this.firstLoad = false;
        }
      } catch (error) {
        console.log(error);
      }
      this.flags.searching = false;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async approve(item) {
      item.loading = true;

      let url = `${this.apiUrl}policies/additional-contributions/approve`;

      let model = {
        additionalContributionId: item.additionalContributionId,
      };
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      try {
        let result = await axios.put(url, model, headers);
        if (result.data !== undefined) {
          this.loadOperations();
        }
      } catch (error) {
        item.loading = false;
      }
    },
    async cancel(item) {
      item.loading = true;

      let url = `${this.apiUrl}policies/additional-contributions/cancel`;

      let model = {
        additionalContributionId: item.additionalContributionId,
      };
      let auth = JSON.parse(window.localStorage.getItem("__auth__"));
      let headers = {
        headers: {
          Authorization: auth.token_type + " " + auth.access_token,
        },
      };

      try {
        let result = await axios.put(url, model, headers);
        if (result.data !== undefined) {
          this.loadOperations();
        }
      } catch (error) {
        item.loading = false;
      }
    },
    changePage(event) {
        console.log(event)
      this.page = event;
      this.loadOperations();
    },
  },
});
</script>

<style lang="scss">
/**/
@import "../../../styles/abstracts/variables";
/**/

.operations {
  &__head {
    margin: 30px 0px 30px 0px;

    &__title {
      font-weight: 500;
      font-size: 28px;
      color: #0855c4;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
    }
  }

  &__body {
    &__load {
      color: $primaryBlue;
      text-align: center;
    }

    .table {
      thead {
        tr {
          th {
            vertical-align: top;
            text-transform: uppercase;
            font-size: 12px;
            letter-spacing: 0.5px;
            color: $primaryGray;
            padding: 0.72rem 1rem;
            border-bottom: 2px solid #ebe9f1;
            background-color: #f3f2f7;
          }
        }
      }

      tbody {
        tr {
          background-color: white;

          td {
            font-size: 14px;
            color: $primaryGray;
            border: none;
            padding: 0.72rem 1rem;
            vertical-align: middle;
            border-top: 1px solid #ebe9f1;

            .badge {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 11px;
              height: 25px;
              width: fit-content;
            }

            a {
              text-decoration: none;
              color: $primaryBlue;
            }

            .delete {
              display: flex;
              align-items: center;
              color: $primaryRed;
              background-color: transparent;
              border: none;

              span {
                display: block;
                padding-left: 10px;
              }
            }

            .badge-success {
              background-color: $green;
            }

            .badge-danger {
              background-color: $primaryRed;
            }

            .badge-purple {
              background-color: $primaryPurple;
            }
          }
        }

        tr:nth-child(even) {
          background-color: transparent;
        }
      }

      & > :not(caption) > * > * {
        box-shadow: none;
      }
    }

    &__table {
      &__actions {
        a {
          &:first-child {
            margin-right: 15px;
            color: $primaryBlue !important;
          }

          &:last-child {
            color: $primaryRed !important;
          }
        }
      }
    }
  }
}
</style>
